<template>
  <div class="hc-modern-form-page">
    <!-- Main Row -->
    <div class="row">
      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Kupon'" card-class="hc-form-card">
          <template v-slot:body>
            <Form :form="form" :route="'coupons'" />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
// import Form from '@/component/masters/coupons/Form.vue'
import Form from "@/component/masters/coupons/Form.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      form: {
        name: "",
        is_percent: "0",
        start_date: "",
        end_date: "",
        amount: "",
        max_amount: 0,
        minimum_purchase: 0,
        usage_limit: null,
        per_patient_limit: 1,
        is_active: true,
        is_stackable: false,
        priority: 0, branch_ids: [], service_channels: [], payment_method_ids: [], patient_segments: [], days_of_week: [], valid_start_time: null, valid_end_time: null,
        description: "",
      },
    };
  },

  components: {
    Card,
    Form,
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Kupon", route: "" },
      { title: "Daftar Kupon", route: "/masters/coupons/list" },
      { title: "Tambah" },
    ]);
  },
};
</script>
